import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  fontFamily: {
    fontFamily: theme.typography.fontFamily
  },
  legendCard: {
    paddingBottom: '16px!important',
    display: 'flex',
    justifyContent: 'end'
  },
  detailedListCardContainer: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  },
  line: {
    flex: 1,
    borderWidth: 1,
    borderColor: theme.palette.divider,
    borderStyle: 'dashed'
  },
  detailedListCardButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  legendContainer: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  filterContainer: {
    display: 'flex',
    justifyContent: 'end'
  },
  switchFormGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  popoverContent: {
    margin: 0,
    padding: theme.spacing(2),
    width: 250
  },
  popoverGridItem: {
    marginBottom: theme.spacing(2)
  },
  switchFormGroupPreLabel: {
    marginRight: theme.spacing(2)
  },
  legendTitle: {
    textAlign: 'center'
  },

  chartContainer: {
    display: 'flex',
    justifyContent: 'center'
  },

  legendFormGroup: {
    paddingLeft: '32px'
  },

  rechartsLabel: {
    fill: '#fff',
    fontWeight: 300,
    fontSize: '12px'
  },

  activityAll: {
    color: theme.palette.text.primary
  },
  activityWalking: {
    color: theme.palette.primary.main
  },
  activityEating: {
    color: theme.palette.warning.main
  },
  activityDrinking: {
    color: theme.palette.info.main
  },
  activityToilet: {
    color: theme.palette.success.main
  },
  activityEnrichment: {
    color: theme.palette.secondary.main
  }
}));
